module.exports = "https://static.cdns.space/classicbook-temp-tx/img/4-2.4564c69d.jpg";